// Override Settings
var boostPFSInstantSearchConfig = {
  search: {
    //suggestionMode: 'test',
    //suggestionPosition: 'left'
    suggestionMobileStyle: 'style2'
  }
};

(function () {
  /* This is to inject boost components into this scope, so we can override component's function */
  BoostPFS.inject(this);
  
  // Customize style of Suggestion box
  // SearchInput.prototype.customizeInstantSearch = function() {
  //   jQ('.boost-pfs-search-suggestion-item-product').each((i, result) => {
  //     var productSKU = jQ(result).find('.boost-pfs-search-suggestion-product-sku').text().replace('SKU: ', '');
  //     if(productSKU) {
  //       jQ.ajax({
  //         method: 'GET',
  //         url: '/search?view=json&q=' + productSKU,
  //         async: false,
  //         success: function(response) {
  //           var res = JSON.parse(response);
  //           if(res.products.length > 0) res = res.products[0];

  //           if(res.wholesale) {
  //             if(res.wholesale.WCProduct_PriceMin > 0) {
  //               var price = jQ(result).find('.boost-pfs-search-suggestion-product-regular-price span');
  //               if(price) jQ(price).html(Utils.formatMoney(res.wholesale.WCProduct_PriceMin / 100));
  //             }
  //           }
  //         }
  //       });
  //     }
  //   });
  // };
})();